module.exports = __webpack_public_path__ + "img/renoncule_des_fleuristes.3af4fea3.jpg";